// extracted by mini-css-extract-plugin
export default {"rating":"mJ-z","numberOfStars":"nJ-z","count":"oJ-z","barGraphSpacing":"pJ-z","barGraph":"qJ-z"};